import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ShellDomainProvider } from '@ecap3/core';

@Pipe({ name: 'customNumberFormat' })
export class CustomNumberFormatPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private _locale: string) { }

  transform(value: any, digitsInfo?: string, locale?: string, isFormatNeeded: boolean = true): string | null {
    let transformedValue: string = "";

    if (!this.isEmpty(value)) {

      if (ShellDomainProvider['api'].fixedDecimalPoint) {
        value = value.toFixed(parseInt(ShellDomainProvider['api'].fixedDecimalPoint));
      }

      const customNumberFormat = ShellDomainProvider['api'].customNumberFormat;
      let decimalPlaceChar, thousandPlaceChar;
      
      if (customNumberFormat) {
        decimalPlaceChar = customNumberFormat[0];
        thousandPlaceChar = customNumberFormat[1];
      }else{
        decimalPlaceChar = ",";
        thousandPlaceChar = ".";
      }

      const isShowDecimalPartForAll = ShellDomainProvider['api'].isShowDecimalPartForAll;
      if(isShowDecimalPartForAll && !digitsInfo){
        const fixedDecimalPoint=ShellDomainProvider['api'].fixedDecimalPoint;
        digitsInfo='1.'+fixedDecimalPoint+'-'+fixedDecimalPoint;
      }


      locale = locale || this._locale;

      const p = new DecimalPipe(locale);
      try {
        let transformedNumber = p.transform(value, digitsInfo, locale);

        if (transformedNumber)
          transformedValue = isFormatNeeded ? transformedNumber.split(",").map(s => s.split(".").join(decimalPlaceChar)).join(thousandPlaceChar) : transformedNumber;
      }
      catch (ex) {
        console.log(ex.message);
      }
    }

    return transformedValue;
  }

  private isEmpty(value: any): boolean {
    return value == null || value === '' || value !== value;
  }
}
